/* generated by pull.js */
const manifest = {
  editorOnly: true,
  name: 'Copy reporter values',
  description:
    'Adds the option to copy values displayed by variable monitors (from the right click context menu) and block reporter balloons.',
  credits: [
    {
      name: 'TheKodeToad'
    }
  ],
  tags: [],
  userscripts: [
    {
      url: 'userscript.js'
    }
  ],
  userstyles: [
    {
      url: 'style.css'
    }
  ],
  dynamicDisable: true
};
export default manifest;
